import { NotificationType } from "@next-platform/client-common-core";

export function copyToClipboard(value: string, attribute: string, displayToast: (args: { message: string; type: NotificationType }) => void) {
  navigator.clipboard
    .writeText(value)
    .then(() => displayToast({ message: `${attribute} copied!`, type: NotificationType.success }))
    .catch(() => displayToast({ message: "Clipboard access must be allowed", type: NotificationType.error }));
}
